import { FC, memo } from 'react';

import MappingRulesPresenter from './MappingRulesPresenter';

const MappingRules: FC = memo(() => (
  <MappingRulesPresenter />
));

export default MappingRules;
